import type { UserInputValidationError } from '@tectonics/prs/validation';

export const validateMobileMoneyNetwork = (
  network: unknown,
  availableNetworks: readonly string[],
): UserInputValidationError | undefined => {
  if (typeof network !== 'string' || network === '') {
    return { id: 'empty' };
  }

  if (!availableNetworks.includes(network)) {
    return { id: 'invalid' };
  }

  return undefined;
};
